<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar dense :color="'#FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="selector-idioma" :aria-label="$t('mensajes.central_reservas.cambiar_idioma')" role="group">
                <v-btn
                    v-for="idioma in idiomasDisponibles"
                    :key="idioma"
                    class="selector-idioma-boton"
                    :class="{ 'selector-idioma-activo': idioma === idiomaActual }"
                    small
                    text
                    :aria-pressed="idioma === idiomaActual"
                    @click="cambiarIdioma(idioma)"
                >
                    {{ idioma.toUpperCase() }}
                </v-btn>
            </div>
        </v-toolbar>
        <v-row no-gutters class="px-2 px-md-6 pb-6">
            <v-col cols="12" md="3" lg="2" class="pt-4 pr-md-4">
                <menu-lateral-central-reservas
                    :opciones="menuLateralOpciones"
                    :activo="menuLateralActual"
                    :color-fondo="'#FBFAF1'"
                    :color-activo="miColorAzul"
                    @seleccionar="seleccionarMenuLateral"
                    @cerrar-sesion="_cerrarSesion"
                />
            </v-col>
            <v-col cols="12" md="9" lg="10" class="pt-4">
                <nueva-solicitud-section
                    v-if="menuLateralActual === 'nueva_solicitud'"
                    :key="nuevaSolicitudKey"
                    :idioma-interfaz="idiomaActual"
                />
                <expedientes-section v-else-if="menuLateralActual === 'expedientes'" />
                <proformas-section v-else-if="menuLateralActual === 'proformas'" />
                <perfil-agencia-section v-else-if="menuLateralActual === 'perfil_agencia'" />
                <ayuda-section v-else />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MenuLateralCentralReservas from '@/components/central-reservas/MenuLateralCentralReservas.vue';
import NuevaSolicitudSection from '@/components/central-reservas/NuevaSolicitudSection.vue';
import ExpedientesSection from '@/components/central-reservas/ExpedientesSection.vue';
import ProformasSection from '@/components/central-reservas/ProformasSection.vue';
import AyudaSection from '@/components/central-reservas/AyudaSection.vue';
import PerfilAgenciaSection from '@/components/central-reservas/PerfilAgenciaSection.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        MenuLateralCentralReservas,
        NuevaSolicitudSection,
        ExpedientesSection,
        ProformasSection,
        AyudaSection,
        PerfilAgenciaSection
    },
    watch: {
        '$route.fullPath': {
            immediate: true,
            handler() {
                this.aplicarIdiomaRuta();
                this.syncMenuFromRoute();
            }
        }
    },
    computed: {
        ...mapState('auth', ['access_token', 'user']),
        idiomaActual() {
            return this.$i18n.locale || 'es';
        },
        idiomasDisponibles() {
            return ['en', 'es', 'de'];
        },
        menuLateralOpciones() {
            return [
                { id: 'nueva_solicitud', titulo: this.$t('mensajes.central_reservas.nueva_solicitud'), icono: 'mdi-book-plus' },
                { id: 'expedientes', titulo: this.$t('mensajes.central_reservas.expedientes_menu'), icono: 'mdi-file-document-multiple' },
                { id: 'proformas', titulo: this.$t('mensajes.central_reservas.invoices_menu'), icono: 'mdi-notebook-multiple' },
                { id: 'perfil_agencia', titulo: this.$t('mensajes.central_reservas.perfil_agencia'), icono: 'mdi-domain' },
                { id: 'ayuda', titulo: this.$t('mensajes.central_reservas.ayuda'), icono: 'mdi-help-circle' }
            ];
        }
    },
    data() {
        return {
            menuLateralActual: 'nueva_solicitud',
            nuevaSolicitudKey: 0,
            miColorAzul: '#191970'
        };
    },
    methods: {
        ...mapActions('auth', ['logOut']),

        aplicarIdiomaRuta() {
            const idioma = String(this.$route.params.language || 'es').toLowerCase();
            this.$i18n.locale = ['es', 'en', 'de'].includes(idioma) ? idioma : 'es';
        },

        cambiarIdioma(idioma) {
            if (!['es', 'en', 'de'].includes(idioma) || idioma === this.idiomaActual) return;

            this.$i18n.locale = idioma;
            this.$router.replace({
                name: this.$route.name,
                params: { ...this.$route.params, language: idioma },
                query: this.$route.query
            }).catch(() => {});
        },

        getMenuValido(menuId) {
            if (!menuId && this.$route.query.codigo) {
                return 'expedientes';
            }

            return this.menuLateralOpciones.some(opcion => opcion.id === menuId)
                ? menuId
                : 'nueva_solicitud';
        },

        syncMenuFromRoute() {
            const menuId = this.getMenuValido(this.$route.query.tab);
            if (this.menuLateralActual !== menuId) {
                this.menuLateralActual = menuId;
            }
        },

        actualizarQueryMenu(menuId) {
            const tab = this.getMenuValido(menuId);
            const queryActual = this.$route.query || {};
            const siguienteQuery = {
                ...queryActual,
                tab
            };

            if (tab !== 'expedientes') {
                delete siguienteQuery.codigo;
            }

            const mismaTab = (queryActual.tab || '') === (siguienteQuery.tab || '');
            const mismoCodigo = (queryActual.codigo || '') === (siguienteQuery.codigo || '');
            if (mismaTab && mismoCodigo) return;

            this.$router.replace({ query: siguienteQuery }).catch(() => {});
        },

        seleccionarMenuLateral(menuId) {
            if (menuId === 'nueva_solicitud') {
                this.nuevaSolicitudKey++;
            }
            this.menuLateralActual = menuId;
            this.actualizarQueryMenu(menuId);
        },

        async _cerrarSesion() {
            await this.logOut([this.access_token]);
            this.$router.push({
                name: 'login',
                params: { language: this.$i18n.locale }
            });
        }
    }
};
</script>

<style scoped>
.selector-idioma {
    position: absolute;
    right: 12px;
    display: flex;
    overflow: hidden;
    border: 1px solid rgba(25, 25, 112, 0.35);
    border-radius: 18px;
}

.selector-idioma-boton {
    min-width: 42px !important;
    border-radius: 0 !important;
}

.selector-idioma-boton + .selector-idioma-boton {
    border-left: 1px solid rgba(25, 25, 112, 0.2);
}

.selector-idioma-activo {
    background-color: rgba(25, 25, 112, 0.12);
    color: #191970;
    font-weight: 600;
}
</style>
